/**
 * The DEMO / PREVIEW marker (run/DEMO-ENV.md). Shown only on hosted preview builds (the `demo` branch deploy and any
 * deploy preview), never on production or a local build. It ignores the pointer so it never blocks a click.
 */
export function PreviewBanner() {
  if (!__PREVIEW__) return null;
  return (
    <div
      role="status"
      data-testid="preview-banner"
      title="A preview of unreleased changes. It uses the live data: test in the demo workspace or a test event."
      className="pointer-events-none fixed bottom-3 left-3 z-banner rounded-full bg-st-warning px-3 py-1 text-[12px] font-bold tracking-wide text-surface shadow-lg ring-1 ring-ink/20 print:hidden"
    >
      DEMO / PREVIEW{__DEPLOY__.branch ? ` · ${__DEPLOY__.branch}` : ''} · live data
    </div>
  );
}
